import { useNavigate } from "react-router-dom";

import { PROCESS_STATUS } from "../utils/consts/processStatus";
import { APP_ROUTES } from "../router";

export default function useRedirect() {
  const history = useNavigate();

  const redirect = processStatus => {
    if (processStatus === PROCESS_STATUS.CHOICE_CONTRACT) {
      history(APP_ROUTES.MOBILE_CONNECTION.CHOICE_CONTRACT_ROUTE);
    } else if (
      processStatus === PROCESS_STATUS.CHOICE_SERVICES ||
      processStatus === PROCESS_STATUS.CHOICE_SERVICES_WITH_CODE_PHRASE
    ) {
      history(APP_ROUTES.MOBILE_CONNECTION.CHOICE_SERVICES_ROUTE);
    } else if (processStatus === PROCESS_STATUS.AWAIT_PAYMENT) {
      history(APP_ROUTES.MOBILE_CONNECTION.PAYMENT_ROUTE);
    } else if (processStatus === PROCESS_STATUS.AWAIT_SIGNING) {
      history(APP_ROUTES.MOBILE_CONNECTION.DOCUMENTS_ROUTE);
    } else if (processStatus === PROCESS_STATUS.CHOICE_DEPARTURE_TIME) {
      history(APP_ROUTES.MOBILE_CONNECTION.CHOICE_DEPARTURE_TIME);
    } else if (
      processStatus === PROCESS_STATUS.CLOSED_WITHOUT_SUPPORT ||
      processStatus === PROCESS_STATUS.AWAIT_DEPARTURE
    ) {
      history(APP_ROUTES.MOBILE_CONNECTION.FINISH_ROUTE);
    }
  };

  return redirect;
}
